<template>
  <el-menu :default-active="$route.path" class="menus" :router="true" :unique-opened="true">
    <template v-for="(item,index) in lists">
      <el-submenu :index="item.path" :key="index" v-if="item.children && item.children.length>0">
        <template slot="title">
          <i class="iconfont" :class="item.icon"></i>
          {{item.title}}
        </template>
        <template v-for="(iitem,iindex) in item.children">
          <el-menu-item :index="iitem.path" :key="iindex">{{iitem.title}}</el-menu-item>
        </template>
      </el-submenu>
      <el-menu-item :index="item.path" :key="index" v-else>
        <template slot="title">
          <i class="iconfont" :class="item.icon"></i>
          {{item.title}}
        </template>
      </el-menu-item>
    </template>
  </el-menu>
</template>
<script>
export default {
  name: "menus",
  data() {
    return {
      active: "",
      lists: [
        {
          title: "基礎設定",
          path: "/dashboard/index",
          icon: "iconjibenxinxi",
          children: [
            {
               title: "首頁新聞設定",
               path: "/dashboard/home-news"
            },
            {
               title: "首頁副圖設定",
               path: "/dashboard/home-secondary"
            },
            {
               title: "首頁專題設定",
               path: "/dashboard/home-special"
            },
            {
               title: "網頁設置",
               path: "/dashboard/webpage"
            },
            {
               title: "一般設置",
               path: "/dashboard/setting"
            },
            {
              title: "廣告管理",
              path: "/dashboard/banner"
            }
          ]
        },

        {
          title: "彈窗管理",
          path: "/popup",
          icon: "iconquanxianguanli",
          children: []
        },

        {
          title: "新聞管理",
          path: "/news/index",
          icon: "iconweibiaoti-",
          children: [
            {
              title: "作者清單",
              path: "/news/author"
            },
            /*{
              title: "比較清單",
              path: "/news/compare"
            },*/
            {
              title: "標籤清單",
              path: "/news/tags"
            },
            {
              title: "新聞分類",
              path: "/news/category"
            },
            {
              title: "繁体新聞列表",
              path: "/news/index?language=tw"
            },
            {
              title: "简体新聞列表",
              path: "/news/index?language=cn"
            },
            {
              title: "英文新聞列表",
              path: "/news/index?language=en"
            },
            {
              title: "新聞來源",
              path: "/news/source"
            },
            {
              title: "視頻清單",
              path: "/video/index"
            }
          ]
        },
        {
          title: "用戶管理",
          path: "/member",
          icon: "iconshouye",
          children: [
            {
              title: "用戶列表",
              path: "/member/index"
            },
            /*{
              title: "用戶文章",
              path: "/member/news"
            },
            {
              title: "用戶评论",
              path: "/member/message"
            }*/
          ]
        },
        {
          title: "反饋管理",
          path: "/feedback",
          icon: "iconshouye",
          children: [
            {
              title: "回報清單",
              path: "/feedback/index"
            },
            {
              title: "檢舉清單",
              path: "/feedback/report"
            }
          ]
        },
        /*{
          title: "爬蟲管理",
          path: "/reptile/index",
          icon: "iconquanxianguanli",
          children: [
            {
              title: "爬蟲管理",
              path: "/reptile/index"
            },
            //{
            //  title: "爬蟲管理2",
            //  path: "/reptile/nindex"
            //},
            // {
            //   title: "來源清單",
            //   path: "/reptile/source"
            // }
          ]
        },
        */
        {
          title: "帳戶管理",
          path: "/manager/index",
          icon: "iconquanxianguanli",
          children: []
        }
      ]
    };
  },
  watch: {
    // 监听路由 控制侧边栏激活状态
    "$route.matched": {
      handler(val) {
        console.log("route:", val);
        const activeName = val[val.length - 1].path;
        // const activeName = val[val.length - 1].meta.activeName;

        console.log("activeName", val[val.length - 1].path);
        // for (let i = 0; i < val.length; i++) {
        //   if (val[i].name === activeName) {
        //     this.active = val[i].path;
        //     break;
        //   }
        // }
        this.active = this.active || activeName;

        console.log("active:", this.active);
      },
      immediate: true
    }
  }
};
</script>
<style lang='less'>
.menus {
  padding-top: 20px;
  border-right: 0;
  background: rgba(40, 47, 73, 1);
  .el-menu-item {
    text-align: left;
    color: #999;
    height: 40px;
    line-height: 40px;
    margin: 4px 0;
    &:hover {
      background: rgba(40, 47, 73, 1) !important;
      color: white !important;
    }
    &.is-active {
      color: #fff !important;
      background: rgba(71, 159, 250, 1) !important;
      i {
        color: #fff !important;
      }
    }
  }
  .el-submenu {
    background: rgba(24, 32, 52, 1);
    .el-menu-item {
      min-width: 150px;
      padding: 0px !important;
    }
    .el-submenu__title {
      background: rgba(40, 47, 73, 1) !important;
      color: #999 !important;
      height: 48px;
      line-height: 48px;
    }
    &.is-opened {
      background: rgba(40, 47, 73, 1) !important;
    }
    &.is-active {
      .el-submenu__title {
        color: white !important;
      }
    }
    &:hover {
      .el-submenu__title {
        color: white !important;
      }
    }
    ul {
      background: rgba(24, 32, 52, 1);
    }
  }
  .el-menu {
    .el-menu-item {
      text-align: center;
    }
  }
  .el-submenu__title {
    text-align: left;
  }
}
</style>